var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isOpenUpdateShiftOneObjectDialog,
            width: "70%",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "2vh",
            title: "Thiết lập chi tiết",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenUpdateShiftOneObjectDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "div",
            { staticClass: "table-content row-data" },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    "empty-text": _vm.textTable,
                    "element-loading-text": _vm.$tableLoading,
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255,255,255, 0)",
                    "highlight-current-row": "",
                    data: _vm.localShiftList,
                    "header-cell-style": _vm.tableHeaderColor,
                    border: "",
                    "max-height": 500,
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "STT",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shiftName",
                      label: "Tên ca",
                      align: "left",
                    },
                  }),
                  _vm._l(_vm.headerTab1List, function (item) {
                    return _c("el-table-column", {
                      key: item.id,
                      attrs: { align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "top",
                                      align: "center",
                                      width: "200",
                                      trigger: "hover",
                                      content: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "truncate-text",
                                        attrs: {
                                          slot: "reference",
                                          title: item.name,
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.name) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("br"),
                                _c("br"),
                                _c("el-checkbox", {
                                  on: {
                                    change: function ($event) {
                                      return _vm.checkHeaderPackageKidsMethod(
                                        scope.$index,
                                        item.id,
                                        item.check
                                      )
                                    },
                                  },
                                  model: {
                                    value: item.check,
                                    callback: function ($$v) {
                                      _vm.$set(item, "check", $$v)
                                    },
                                    expression: "item.check",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-checkbox", {
                                  attrs: { disabled: !scope.row.assigned },
                                  on: {
                                    change: () => {
                                      _vm.updateAssignedForRow(scope.row)
                                      _vm.updateHeaderCheck(item.id)
                                    },
                                  },
                                  model: {
                                    value: scope.row.dayList.find(
                                      (d) => d.id === item.id
                                    ).active,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row.dayList.find(
                                          (d) => d.id === item.id
                                        ),
                                        "active",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "scope.row.dayList.find(d => d.id === item.id).active",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      label: "Áp dụng bữa ăn",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "Chọn bữa ăn",
                                  multiple: "",
                                  "collapse-tags": "",
                                  disabled:
                                    !scope.row.applyAttendanceEat ||
                                    !scope.row.assigned,
                                },
                                model: {
                                  value: scope.row.meals,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "meals", $$v)
                                  },
                                  expression: "scope.row.meals",
                                },
                              },
                              _vm._l(
                                _vm.valueAttendanceEatList,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      value: item.value,
                                      label: item.label,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tab-infor-button" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleSave()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Lưu")]),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialog()
                    },
                  },
                },
                [_c("span", [_vm._v("Đóng")])]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }